import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { Button, TextField } from "components"
import classes from "./TdAutoGenerate.module.scss"

const initialFormState = {
  level: "",
  numberOfTables: ""
}

const TdAutoGenerate = props => {
  const { setTables, setLayout, setSelectedFloor } = props

  const [t] = useTranslation()

  const [form, setForm] = useState(initialFormState)
  const [formErrors, setFormErrors] = useState(initialFormState)

  const handleChange = (value, name) => {
    setForm(prev => ({
      ...prev, [name]: value
    }))
  }

  const validate = () => {
    const errors = { ...initialFormState }
    let result = true

    if (isNaN(form.numberOfTables)) {
      result = false

      errors["numberOfTables"] = t("تعداد_میز_نا_معتبر_است")
    }

    if (Number(form.numberOfTables) <= 0) {
      result = false

      errors["numberOfTables"] = t("تعداد_میز_نا_معتبر_است")
    }

    if (Number(form.numberOfTables) > 50) {
      result = false

      errors["numberOfTables"] = t("تعداد_میز_نا_معتبر_است")
    }

    if (!form.level) {
      result = false

      errors["level"] = t("طبقه_الزامی_است")
    }

    setFormErrors(errors)

    return result
  }

  const handleCreate = () => {
    if (!validate()) return

    const number = Number(form.numberOfTables | 0)

    const newTables = []

    for (let i = 0; i < number; i++) {
      newTables.push({
        available: true,
        status: "ready",
        tableNumber: String(i + 1),
        level: form.level,
        capacity: 2,
        shape: "square",
        scale: "small",
        position: {
          x: -i * 0.005,
          y: 0
        }
      })
    }

    setSelectedFloor(form.level)

    setTables(newTables)

    setLayout("list")
  }

  return (
    <div className={classes["container"]}>
      <div className={classes["input"]}>
        <TextField

          error={formErrors.numberOfTables}
          value={form.numberOfTables}
          label={t("تعداد_میز_ها")}
          onChange={e => handleChange(e.target.value, "numberOfTables")}
        />
      </div>
      <div className={classes["input"]}>
        <TextField
          label={t("طبقه")}
          error={formErrors.level}
          value={form.level}
          onChange={e => handleChange(e.target.value, "level")}
        />
      </div>
      <Button
        color="success"
        onClick={handleCreate}
      >
        {t("افزودن")}
      </Button>
    </div>
  )
}

export default TdAutoGenerate